import React, { useEffect, useRef, useState } from "react";
import "./ViewSessionHistoryPopup.css"; 
import { usePlayerAccount } from "../../APIContext/PlayerAccountContext";

const ViewSessionHistoryPopup = ({ isOpen, onClose, title, children , pid }) => {
    const { fetchPlayersPackages } = usePlayerAccount();
    const [ history, setHistory ] = useState([]);
    function getLocalDate(utcDateTime) {
        const localDate = new Date(utcDateTime);
        return localDate.toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
        });
    }

    useEffect(() => {
        if (!pid) return;

        const loadHistory = async () => {
        try {
            const response = await fetchPlayersPackages(pid);
            setHistory(response?.data || []);
        } catch (err) {
            console.error("Failed to load history:", err);
        }
        };

        loadHistory();
    }, [pid]);


 
  
  if (!isOpen) return null;




  return (
    <div className="ViewSessionHistoryPopup popup-overlay" onClick={onClose}>
      <div className="popup-container">
        
        <div className="popup-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="popup-body">
         <div className="player-stats-section">
              <hr className="divider" />
              <div className="package-table">
                <div className="table-header">
                  <span>Package Name</span>
                  <span>Price</span>
                  <span>Remaining Sessions</span>
                  <span>Type</span>
                  <span>Date</span>
                  <span>Status</span>
                </div>

                {history.length > 0 ? (
                  history.map((item, index) => (
                    <div className="table-row" key={index}>
                      <span>{item.package?.name || ""}</span>
                      <span>{item.package?.price || ""}</span>
                      <span>{item.remaining_sessions || ""}</span>
                      <span>{item.is_unlimited ? "Unlimited" : "Limited"}</span>
                      <span>{getLocalDate(item.start_date)}</span>
                      <span>{item.status || ""}</span>
                    </div>
                  ))
                ) : (
                  <div className="no-package">No Packages Available</div>
                )}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSessionHistoryPopup;
